import mock from './mock';

export default mock;



// WEBPACK FOOTER //
// ./src/api/mock/index.js